import {
  UPDATE_ADVERTISEMENT_ERROR,
  UPDATE_ADVERTISEMENT_START,
  UPDATE_ADVERTISEMENT_SUCCESS,
} from 'constants/action-types/communication/updateAdvertisement';

export default (state, { type, payload }) => {
  switch (type) {
    case UPDATE_ADVERTISEMENT_START:
      return {
        ...state,
        updateAdvertisement: {
          loading: true,
          message: null,
          data: [],
        },
      };
    case UPDATE_ADVERTISEMENT_ERROR:
      return {
        ...state,
        updateAdvertisement: {
          ...state.updateAdvertisement,
          error: payload,
          loading: false,
        },
      };
    case UPDATE_ADVERTISEMENT_SUCCESS:
      return {
        ...state,
        updateAdvertisement: {
          ...state.updateAdvertisement,
          data: payload,
          loading: false,
        },
      };
    default:
      return null;
  }
};
